import { createValidationErrors } from 'ui';
import { DefaultFiltersTranslation } from '../constants';
import { DefaultFilter, DefaultFilterValidation, FilterState } from '../types-store';

const validateDefaultFilter = (
  defaultFilter: DefaultFilter,
  translation: DefaultFiltersTranslation
): DefaultFilterValidation => {

  return {
    ...(defaultFilter.state === FilterState.DefaultValue &&
      !defaultFilter.defaultValue?.value && !defaultFilter.myValue && {
      defaultValue: createValidationErrors([translation.must_be_filled_out])
    }),
    ...(defaultFilter.state === FilterState.Range &&
      !defaultFilter.defaultValue?.value && !defaultFilter.defaultValue2?.value && {
      defaultValue: createValidationErrors([translation.at_least_one_must_be_filled_out])
    }),
    ...(defaultFilter.state === FilterState.FixedPeriod &&
      !defaultFilter.periodPredef?.value && {
      periodPredef: createValidationErrors([translation.must_be_filled_out])
    })
  };
};

export const validateDefaultFilters = (
  defaultFilters: DefaultFilter[] = [],
  translation: DefaultFiltersTranslation
): { [domain: number]: DefaultFilterValidation } =>
  defaultFilters
    .reduce((result, defaultFilter) => {

      const validation = validateDefaultFilter(defaultFilter, translation);

      return Object.keys(validation).length > 0
        ? {
          ...result,
          [defaultFilter.domain.value]: validation
        }
        : result;
    }, {} as { [domain: number]: DefaultFilterValidation });
